// import 'preact/debug';
import $ from 'jquery';
import mousewheel from 'jscrollpane/script/jquery.mousewheel.js';
import slick from 'slick-carousel';
import selectize from './selectize.jquery.js';
import popup from './popup.jquery.js';
import scroll from './scroll.js';
import header from './header.js';
import main from './main.js';
import catalogue from './catalogue.js';
import product from './product.js';
import downloads from './downloads.js';
import services from './services.js';
import sellingPoints from './selling-points.js';
import feedback from './feedback.js';
import contacts from './contacts.js';
import * as React from 'preact';

window.React = React;

mousewheel($);

if ('NodeList' in window && !NodeList.prototype.forEach) {

    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}


const selectization = function() {
    $('.selectize').selectize();
}

$(function() {
    scroll();
    selectization();
    header();
    main();
    catalogue();
    product();
    downloads();
    services();
    sellingPoints();
    feedback();
    contacts();
})
